<template>
  <div>
    <component
      v-if="providerComponent && bookingData"
      :is="providerComponent"
      :key="componentKey"
      :booking-data="bookingData"
    />
  </div>
</template>

<script>
import { _getBooking } from "@/services/Payment";
import InfocabPromotion from "./promotionNUDG/providers/InfocabPromotion.vue";
import AutocabPromotion from "./promotionNUDG/providers/AutocabPromotion.vue";
import iCabbiPromotion from "./promotionNUDG/providers/iCabbiPromotion.vue";

/**
 * Provider Configuration
 *
 * To add a new provider:
 * 1. Create a new component in ./promotionNUDG/providers/YourProviderPromotion.vue
 * 2. Import it above (e.g., import YourProviderPromotion from "./promotionNUDG/providers/YourProviderPromotion.vue")
 * 3. Add it to the components object below
 * 4. Add the mapping here: 'providername': 'YourProviderPromotion'
 *
 * The provider name should match what comes from the API (case-insensitive)
 */
const PROVIDER_MAP = {
  infocab: 'InfocabPromotion',
  autocab: 'AutocabPromotion',
  icabbi: 'iCabbiPromotion',
};

const DEFAULT_PROVIDER = 'autocab';

function fetchFreshBooking(bid) {
  return _getBooking(bid).then((res) => res.data.obj);
}

function resolveProviderComponent(provider) {
  const providerName = provider ? String(provider).toLowerCase() : null;

  if (providerName && PROVIDER_MAP[providerName]) {
    return PROVIDER_MAP[providerName];
  }

  console.warn(`Provider "${provider}" not found, using default: ${DEFAULT_PROVIDER}`);
  return PROVIDER_MAP[DEFAULT_PROVIDER];
}

export default {
  name: 'PromotionNUDG',
  components: {
    InfocabPromotion,
    AutocabPromotion,
    iCabbiPromotion,
  },
  data() {
    return {
      provider: null,
      providerComponent: null,
      bookingData: null,
      componentKey: null,
      bid: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    document.documentElement.style.overflow = 'hidden';

    fetchFreshBooking(to.params.bid)
      .then((booking) => {
        next((vm) => {
          vm.applyBooking(booking, to.params.bid);
        });
      })
      .catch((error) => {
        next((vm) => vm.handleFetchError(error));
      });
  },
  beforeRouteUpdate(to, from, next) {
    document.documentElement.style.overflow = 'hidden';
    this.$vs.loading();

    fetchFreshBooking(to.params.bid)
      .then((booking) => {
        this.applyBooking(booking, to.params.bid);
        this.$nextTick(() => {
          this.$vs.loading.close();
        });
        next();
      })
      .catch((error) => {
        this.handleFetchError(error);
        next(false);
      });
  },
  methods: {
    applyBooking(booking, bid) {
      this.bid = bid;
      this.bookingData = booking;
      this.provider = booking.booking_provider;
      this.providerComponent = resolveProviderComponent(this.provider);
      this.componentKey = `${bid}-${Date.now()}`;
    },
    handleFetchError(error) {
      this.$vs.loading.close();
      this.$vs.notify({
        title: 'Error',
        text:
          (error.response && error.response.data && error.response.data.message) ||
          'Failed to load booking',
        iconPack: 'feather',
        icon: 'icon-cross-circle',
        color: 'danger',
      });
    },
  },
};
</script>
